import React, { PureComponent } from 'react'
import Checkbox from '../../../Components/Checkbox'
import BlinkingMarker from '../../../Components/BlinkingMarker'
import { setup } from 'bem-cn';

const block = setup({
    mod: '--'
})

const b = block('CalendarSwitcher')

export default class CalendarSwitcher extends PureComponent {

    clickHandler = (event) => {
        event.preventDefault()

        this.props.onClick && this.props.onClick({
            id: this.props.id
        })
    }

    render() {

        const { name, color, enabled, showMarker } = this.props
        return (
            <label className={b()} onClick={this.clickHandler}>
                {showMarker && <BlinkingMarker top={11} size={11} />}
                <span className={b('checkbox', { checked: enabled })}>
                    <Checkbox enabled={enabled} />
                </span>
                <span className={b('color')} style={ { backgroundColor: color } }></span>
                <span className={b('title')}>{name}</span>
            </label>
        )
    }
}